
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { initClient } from '../../../api';
import { SurveyJsUiClient, SurveyResultView } from '../../backend/backendapi';
import { Results, VgtParameters } from './VgtRemoteManger';
import ResultsTable from './ResultsTable';

@Component({
  name: 'SurveyResultsComponent',
  components: {
    ResultsTable,
  },
})
export default class SurveyResultsComponent extends Vue {
  @Prop({ required: true })
  surveyId!: string;

  private readonly api = initClient(SurveyJsUiClient);
  loadingFunction = this.loadResults.bind(this);

  private async loadResults(params: VgtParameters): Promise<Results<SurveyResultView>> {
    const data = await this.api.listResult(this.surveyId, params.pagination.page, params.pagination.perPage, params.filter, params.sort, params.search);   
    return data as Results<SurveyResultView>;
  }
}
